export default function getDateFromCJUrl(
  year: string,
  month: string,
  day: string,
): Date {
  const yearNumber = parseInt(year, 10);
  const monthNumber = parseInt(month, 10);
  const dayNumber = parseInt(day, 10);
  return !yearNumber || !monthNumber || !dayNumber
    ? new Date()
    : new Date(yearNumber, monthNumber - 1, dayNumber);
}
